export const ROUTE_NAMES = {
  NONE_EXISTING_PAGE: "*",
  HOME: "/",
  PRODUCTS: `/products`,
  PRODUCTS_CATEGORIES: `/products/:category`,
  ALL_PRODUCTS: `/products/all`,
  PRODUCT: "/products/:category/:name",
  PALETTE: `/palette`,
  ABOUT: "/about",
};
